export default [
  {
    path: "",
    component: () => import("./moduleLayout.vue"),
    meta: {
      whiteListed: true,
    },
    children: [
      {
        path: "signup",
        name: "home-signup",
        component: () => import("./pages/signup/index.vue"),
        meta: {
          layout: "full",
          resource: "Auth",
          redirectIfLoggedIn: false,
          whiteListed: true,
          header: "main",
        },
      },
      {
        path: "",
        name: "home",
        component: () => import("./pages/main/index.vue"),
        meta: {
          layout: "full",
          header: "main",
          whiteListed: true,
        },
      },
      {
        path: "about-platform",
        name: "about-platform",
        component: () => import("./pages/about-platform/index.vue"),
        meta: {
          layout: "full",
          header: "main",
          whiteListed: true,
        },
      },
      {
        path: "ngo-list",
        name: "ngo-list",
        component: () => import("./pages/ngo-list/index.vue"),
        meta: {
          layout: "full",
          header: "main",
          whiteListed: true,
        },
      },
      {
        path: "ngo/:id",
        name: "ngo-home",
        props: true,
        component: () => import("./pages/ngo-main/index.vue"),
        meta: {
          layout: "full",
          whiteListed: true,
        },
      },
      {
        path: "ngo/:id/activities",
        name: "activities",
        props: true,
        component: () => import("./pages/news/index.vue"),
        meta: {
          layout: "full",
          whiteListed: true,
        },
      },
      {
        path: "ngo/:id/activities/:activityId",
        name: "activity",
        props: true,
        component: () => import("./pages/activity/index.vue"),
        meta: {
          layout: "full",
          whiteListed: true,
        },
      },
      {
        path: "ngo/:id/contact-us",
        name: "ngo-contact-us",
        props: true,
        component: () => import("./pages/contact-us/index.vue"),
        meta: {
          layout: "full",
          whiteListed: true,
        },
      },
      {
        path: "ngo/:id/donation",
        name: "ngo-donation",
        props: true,
        component: () => import("./pages/donation/index.vue"),
        meta: {
          layout: "full",
          whiteListed: true,
        },
      },
      {
        path: "donation",
        name: "donation",
        props: true,
        component: () => import("./pages/platform-donation/index.vue"),
        meta: {
          layout: "full",
          header: "main",
          whiteListed: true,
        },
      },

      {
        path: "about-ministry",
        name: "about-ministry",
        props: true,
        component: () => import("./pages/about-ministry/index.vue"),
        meta: {
          layout: "full",
          header: "main",

          whiteListed: true,
        },
      },
      {
        path: "/legal-references/laws",
        name: "laws",
        props: true,
        component: () => import("./pages/legal-references/laws/index.vue"),
        meta: {
          layout: "full",
          header: "main",

          whiteListed: true,
        },
      },
      {
        path: "/legal-references/view/:id",
        name: "regulation-view",
        props: true,
        component: () =>
          import("./pages/legal-references/regulation-view/index.vue"),
        meta: {
          layout: "full",
          header: "main",
          whiteListed: true,
        },
      },
      {
        path: "/legal-references/decrees",
        name: "decrees",
        props: true,
        component: () => import("./pages/legal-references/decrees/index.vue"),
        meta: {
          layout: "full",
          header: "main",

          whiteListed: true,
        },
      },
      {
        path: "/legal-references/circulars",
        name: "circulars",
        props: true,
        component: () => import("./pages/legal-references/circulars/index.vue"),
        meta: {
          layout: "full",
          header: "main",

          whiteListed: true,
        },
      },
      {
        path: "/legal-references/decisions",
        name: "decisions",
        props: true,
        component: () => import("./pages/legal-references/decisions/index.vue"),
        meta: {
          layout: "full",
          header: "main",

          whiteListed: true,
        },
      },
      {
        path: "/legal-references/systems",
        name: "systems",
        props: true,
        component: () => import("./pages/legal-references/system/index.vue"),
        meta: {
          layout: "full",
          header: "main",

          whiteListed: true,
        },
      },
      {
        path: "/dealing-mechanism",
        name: "dealing-mechanism",
        props: true,
        component: () => import("./pages/dealing-mechanism/index.vue"),
        meta: {
          layout: "full",
          header: "main",

          whiteListed: true,
        },
      },
      {
        path: "/ramadanCampaign",
        name: "ramadanCampaign",
        props: true,
        component: () => import("./pages/ramadan-campaign/index.vue"),
        meta: {
          layout: "full",
          header: "main",
          whiteListed: true,
        },
      },
      {
        path: "/earthquakes",
        name: "earthquakes",
        props: true,
        component: () => import("./pages/earthquake-page/index.vue"),
        meta: {
          layout: "full",
          header: "main",
          whiteListed: true,
        },
      },
      {
        path: "general-activities",
        name: "general-activities",
        props: true,
        component: () => import("./pages/general-activities/index.vue"),
        meta: {
          layout: "full",
          header: "main",

          whiteListed: true,
        },
      },
      {
        path: "/standard-guide",
        name: "standard-guide",
        props: true,
        component: () => import("./pages/standard-guide/index.vue"),
        meta: {
          layout: "full",
          header: "main",

          whiteListed: true,
        },
      },
      {
        path: "/jobs",
        name: "jobs",
        props: true,
        component: () => import("./pages/jobs/index.vue"),
        meta: {
          layout: "full",
          header: "main",

          whiteListed: true,
        },
      },
      {
        path: "ngo/:id/ngo-jobs",
        name: "ngo-jobs",
        props: true,
        component: () => import("./pages/jobs/index.vue"),
        meta: {
          layout: "full",
          whiteListed: true,
        },
      },
      {
        path: "/jobs-info/:id_info",
        name: "jobs-info",
        props: true,
        component: () => import("./pages/jobs-info/index.vue"),
        meta: {
          layout: "full",
          whiteListed: true,
          header: "main",
        },
      },
      {
        path: "/volunteer-info/:id_info",
        name: "volunteer-info",
        props: true,
        component: () => import("./pages/jobs-info/index.vue"),
        meta: {
          layout: "full",
          whiteListed: true,
          header: "main",
        },
      },
      {
        path: "ngo/:id/jobs-info/:id_info",
        name: "jobs-info-ngo",
        props: true,
        component: () => import("./pages/jobs-info/index.vue"),
        meta: {
          layout: "full",
          whiteListed: true,
        },
      },
      {
        path: "ngo/:id/volunteer-info/:id_info",
        name: "volunteer-info-ngo",
        props: true,
        component: () => import("./pages/jobs-info/index.vue"),
        meta: {
          layout: "full",
          whiteListed: true,
        },
      },
      {
        path: "ngos-map",
        name: "ngos-map",
        props: true,
        component: () => import("./pages/ngos-map/index.vue"),
        meta: {
          layout: "full",
          header: "main",

          whiteListed: true,
        },
      },
      {
        path: "ngos-statistics",
        name: "ngos-statistics",
        props: true,
        component: () => import("./pages/ngos-statistics/index.vue"),
        meta: {
          layout: "full",
          header: "main",

          whiteListed: true,
        },
      },
      {
        path: "ngo-create-steps",
        name: "create-steps",
        props: true,
        component: () => import("./pages/create-steps/index.vue"),
        meta: {
          layout: "full",
          header: "main",

          whiteListed: true,
        },
      },
      {
        path: "/volunteer",
        name: "volunteer",
        props: true,
        component: () => import("./pages/volunteer/index.vue"),
        meta: {
          layout: "full",
          header: "main",

          whiteListed: true,
        },
      },
      {
        path: "ngo/:id/ngo-volunteer",
        name: "ngo-volunteer",
        props: true,
        component: () => import("./pages/volunteer/index.vue"),
        meta: {
          layout: "full",
          whiteListed: true,
        },
      },
      {
        path: "/faq",
        name: "home-faq",
        props: true,
        component: () => import("./pages/FAQ/index.vue"),
        meta: {
          layout: "full",
          header: "main",
          whiteListed: true,
        },
      },
      // {
      //   path: "ngo/how-to-support-me/:id",
      //   name: "how-to-support-me",
      //   props: true,
      //   component: () =>
      //     import("./pages/assest-pages/how-to-support-me/index.vue"),
      //   meta: {
      //     layout: "full",
      //     whiteListed: true,
      //   },
      // },
      // {
      //   path: "ngo/how-to-get-support/:id",
      //   name: "how-to-get-support",
      //   props: true,
      //   component: () =>
      //     import("./pages/assest-pages/how-to-get-support/index.vue"),
      //   meta: {
      //     layout: "full",
      //     whiteListed: true,
      //   },
      // },
      {
        path: "details_donation/:id",
        name: "details_donation",
        props: true,
        component: () => import("./pages/details-donation/index.vue"),
        meta: {
          layout: "full",
          whiteListed: true,
          header: "main",
        },
      },
      {
        path: "ngo/:id/details_donation/:details_donation_id",
        name: "ngo_details_donation",
        props: true,
        component: () => import("./pages/details-donation/index.vue"),
        meta: {
          layout: "full",
          whiteListed: true,
        },
      },
      {
        path: "ngo/:id/ngo-founders",
        name: "ngo-founders",
        props: true,
        component: () => import("./pages/founders/index.vue"),
        meta: {
          layout: "full",
          whiteListed: true,
        },
      },
      {
        path: "ngo/:id/ngo-trustees",
        name: "ngo-trustees",
        props: true,
        component: () => import("./pages/founders/index.vue"),
        meta: {
          layout: "full",
          whiteListed: true,
        },
      },
      {
        path: "ngo/:id/ngo-admins",
        name: "ngo-admins",
        props: true,
        component: () => import("./pages/founders/index.vue"),
        meta: {
          layout: "full",
          whiteListed: true,
        },
      },
      {
        path: "ngo/:id/ngo-excutives",
        name: "ngo-excutives",
        props: true,
        component: () => import("./pages/founders/index.vue"),
        meta: {
          layout: "full",
          whiteListed: true,
        },
      },
      {
        path: "ngo/:id/events",
        name: "ngo-events",
        props: true,
        component: () => import("./pages/ngo-events/index.vue"),
        meta: {
          layout: "full",
          whiteListed: true,
        },
      },
      {
        path: "use-policy",
        name: "use-policy",
        props: true,
        component: () => import("./pages/use-policy/index.vue"),
        meta: {
          layout: "full",
          whiteListed: true,
          header: "main",
        },
      },
    ],
  },
];
